export const ROUTE_NAMES = {
  LIST: 'statements-eur'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'statements-eur/list'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/list'], resolve)
  }
]
